(ns minorodata.group.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]
            [minorodata.app.utils :as utils]))


(reg-event-fx
  :group.events/save-group-updates
  (fn [_ [group cb-params]]
    (let [{:keys [name description schedule-spec]} group
          events (utils/conj-when
                   []
                   (some? (or name description))
                   [:group.api/update-group group cb-params]

                   (some? schedule-spec)
                   [:group.api/bulk-schedule-group group cb-params])]
      {:dispatch-n events})))


(reg-event-fx
  :group.events/search-groups
  (fn [_ [term]]
    (let [params (-> {:filters {:type :group}}
                     (assoc :query (or term "")
                            :pagination utils/default-pagination))]
      {:dispatch [:transformations.api/load-search-results params]})))


(reg-event-fx
 :group.events/clean-up-new-transform-template-code
 (fn [_ _]
   {:clear-local-storage "new-transform-template-code"}))
